import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import { camelCase } from 'lodash'
import { string } from 'prop-types'

const componentCase = (str: string) => {
  const camel = camelCase(str)
  return camel.charAt(0).toUpperCase() + camel.slice(1)
}

interface IconProps extends React.HTMLAttributes<HTMLElement> {
  kind: string
  srText?: string
  className?: string
}

const Icon = ({ kind, srText, className, ...props }: IconProps) => {
  const [Component, setComponent] = useState(null)

  useEffect(() => {
    let isCancelled = false
    const loadIcon = async () => {
      const componentName = componentCase(kind)
      import(`./${componentName}.tsx`)
        .then(({ default: Comp }) => {
          if (!isCancelled) {
            setComponent(() => Comp)
          }
        })
        // eslint-disable-next-line no-console
        .catch((e: unknown) => console.warn(e))
    }

    loadIcon()

    return () => {
      isCancelled = true
    }
  }, [kind])

  const Comp = Component || 'span'

  return (
    <>
      {!!srText && <span className='mc-sr-only'>{srText}</span>}
      <Comp
        {...props}
        aria-hidden={true}
        className={cn({
          'mc-icon': true,
          [className ?? '']: !!className,
          'mc-icon--placeholder': !Component,
        })}
        role='img'
      />
    </>
  )
}

Icon.propTypes = {
  className: string,
  kind: string,
  srText: string,
}

export default Icon
